import permissions from './index'
import { default_redirect } from './index'

/**
 * Wrapper function for OR logic in permissions
 * 
 * @param {array} orGroups - list of groups of rules to be checked with OR logic
 * @param {object} redirect - name of the route for redirect
 */
export function orPermissions(orGroups, redirect) {
    return function(to, from, next) {
        let group_verifying = []

        for (let i = 0; i < orGroups.length; i++) {
            const group = orGroups[i]
            const groupPromise = new Promise((resolve, reject) => {
                const groupPermissions = permissions(group, redirect)
                groupPermissions(to, from, (result) => {
                    if (result instanceof Error) {
                        reject(result)
                    } else {
                        resolve(result)
                    }
                })
            })
            group_verifying.push(groupPromise)
        }

        Promise.allSettled(group_verifying).then(results => {
            if (results.some(result => result.status === 'fulfilled')) {
                next()
            } else {
                next({
                    replace: true,
                    ...(redirect || default_redirect),
                    params: { $referrer: to },
                })
            }
        })
    }
}